module.exports = __webpack_public_path__ + "img/13.1871e6ea.png";